export const CCS_POLYGON_TOLERANCE = 1e-5;

export default { CCS_POLYGON_TOLERANCE };
